import { X } from 'lucide-react'

import { cn } from 'src/shared/utils/cn'

import { FileIcon } from '../icons/file'

interface UploadedFileCardProps {
  fileName: string
  fileSize: number
  onRemove: () => void
  className?: string
}

const formatFileSize = (sizeInBytes: number) => {
  if (sizeInBytes < 1024 * 1024) {
    return `${Math.max(1, Math.round(sizeInBytes / 1024))}KB`
  }

  return `${(sizeInBytes / (1024 * 1024)).toFixed(1)}MB`
}

export default function UploadedFileCard({ fileName, fileSize, onRemove, className }: UploadedFileCardProps) {
  return (
    <div className={cn('flex w-full items-center justify-center', className)}>
      <div className="relative flex h-[80px] w-full max-w-[350px] items-center rounded-[15px] border border-lightBorder bg-accent py-[14px] pl-[24px] pr-[16px]">
        <FileIcon size={24} className="shrink-0 text-primary" />
        <div className="ml-3 min-w-0 pr-6">
          <p className="truncate text-[14px] font-semibold leading-[1.6] text-primary">{fileName}</p>
          <p className="text-[12px] font-medium leading-[1.6] text-muted">CSV · {formatFileSize(fileSize)}</p>
        </div>
        <button
          type="button"
          className="absolute right-[14px] top-[14px] ml-auto flex size-[26px] items-center justify-center rounded-full bg-transparent text-primary hover:bg-primary hover:text-white"
          aria-label="Remove uploaded file"
          onClick={onRemove}
        >
          <X className="size-[14px]" strokeWidth={2} />
        </button>
      </div>
    </div>
  )
}
